import React from 'react'
import { NUM_CATEGORIES } from '@mc/constants'
import { useTranslation } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import CTA from 'components/CTA'
import { PricingText } from 'components/PricingText'

export const ConsumerCallout = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <div className='container d-flex flex-column flex-fill justify-content-end mc-py-4'>
      <div className='d-flex flex-column align-items-center mc-bg-container-tint-medium mc-py-4 mc-text--center mc-corners--md'>
        <h2 className='mc-text-h4 mc-mb-2'>{t('nav.callout.title')}</h2>
        <p className='mc-mb-5'>
          {t('nav.callout.subtitle', {
            instructors: getNumberOfInstructors(),
            categories: NUM_CATEGORIES,
          })}
        </p>
        <CTA
          className='mc-w-fit-content mc-px-10'
          trackProps={{
            category: 'video-playlist-module',
            content_type: 'product',
            level: 'secondary',
            location: 'navigation',
            page_category: 'class',
            page_source: 'navigation',
          }}
        />
        <p className='mc-mt-3 mc-text-small'>
          <PricingText translationKey='short' />
        </p>
      </div>
    </div>
  )
}
